import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegExpPatterns } from '../utilites/regex-pattern';
import { PropertyService } from '../../services/property/property.service';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {

  center: google.maps.LatLngLiteral = { lat: 15.2, lng: 78.8 };
  zoom = 7;
  mapOptions: google.maps.MapOptions = {
    styles: [
      {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
          { "saturation": -100 },
          { "lightness": 0 }
        ]
      }
    ],
    disableDefaultUI: true,

  };



  // --- Marker Configuration ---
  markerPosition1: google.maps.LatLngLiteral = { lat: 12.976794, lng: 77.590083 };
  markerTitle1 = "Bangalore Office";
  markerPosition2: google.maps.LatLngLiteral = { lat: 17.3864, lng: 78.4919 };
  markerTitle2 = "Hyderabad Office";


  contactUsForm!   : FormGroup;
  showResponseData : boolean = false;
  errorMessage     : any;
  message          : any;
  public readonly faMail = faEnvelope;
  public readonly faPhone = faPhone;

  constructor(private fb: FormBuilder,
    private propertyService: PropertyService
  ) { }

  ngOnInit(): void {
    this.generateContactForm();

       this.adjustMapToBounds();
  }

  adjustMapToBounds(): void {

    const bounds = new google.maps.LatLngBounds();


    bounds.extend(this.markerPosition1);
    bounds.extend(this.markerPosition2);

    const centerLat = (this.markerPosition1.lat + this.markerPosition2.lat) / 2;
    const centerLng = (this.markerPosition1.lng + this.markerPosition2.lng) / 2;
    this.center = { lat: centerLat, lng: centerLng };


    this.zoom = 7;

  }

  generateContactForm() {
    this.contactUsForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(RegExpPatterns.name)]],
      email: ['', [Validators.required, Validators.pattern(RegExpPatterns.EmailPattern)]],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(RegExpPatterns.MobilePattern),
      ]],
    })
  }

  sendMessage(){}

  addContactusDetails() {
    const payload = {
      name: this.contactUsForm.value.name,
      email: this.contactUsForm.value.email,
      phoneNumber: this.contactUsForm.value.phoneNumber
    }
    this.propertyService.addContactusDetails(payload).subscribe({
      next: (res: any) => {
        if (res) {
          this.contactUsForm.reset();
          this.message = 'Thank You. We Will Conatct You Soon';
          this.clearErrorMessageAfterTimeout();
        }
      },
      error: (error: any) => {
        this.errorMessage = error?.error?.error?.message;
      },

    })
  }

  clearErrorMessageAfterTimeout() {
    setTimeout(() => {
      this.message = '';
    }, 3000);
  }
}
